

  // Custom JS Code Start
(function () {
  const ITEM_SELECTOR = '.item'; // parent item wrapper
  const FLAG_SELECTOR = '.item-properties-list-element[data-item-property="c_size_checked"]';
  const CUSTOM_CLASS  = 'is-custom-mattress';

  function normalize(val) {
    return String(val || '').trim().toLowerCase();
  }

  function apply() {
    document.querySelectorAll(ITEM_SELECTOR).forEach(item => {
      const flagEl = item.querySelector(FLAG_SELECTOR);
      const val = flagEl ? normalize(flagEl.textContent) : '';
      const isCustom = (val === 'true' || val === '1' || val === 'yes');
      console.log("preet:custom size");
      item.classList.toggle(CUSTOM_CLASS, isCustom);
    });
  }

  // Run now and on DOM updates (cart drawer is dynamic)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });

  // If your cart emits a custom update event, listen to it too:
  window.addEventListener('gokwik:cart:updated', apply);
})();
// Custom JS Code end
